<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button cdkFocusInitial (click)="onClick()">Close</button>
</mat-dialog-actions>
